module.exports = __webpack_public_path__ + "static/media/parents-child.4ff8ffdd.png";